// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1l2TL","title":"Info_title__3gFHP","links":"Info_links__3gICA","link":"Info_link__3KW6i","logo":"Info_logo__22Mwj"};